import { render, staticRenderFns } from "./form-supplementary-external.vue?vue&type=template&id=2b9b2ba9&"
import script from "./form-supplementary-external.vue?vue&type=script&lang=js&"
export * from "./form-supplementary-external.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports